import React                       from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import OurTeamFront                from './OurTeamFront';
import OurTeamMember               from './OurTeamMember';
import { getRoute, getSubRoute }   from 'pursuit/routes/routes';

export default function OurTeam() {
    return (
        <Routes>
            <Route path="/" element={<OurTeamFront />} />
            <Route
                element={<OurTeamMember />}
                path={getSubRoute('ourTeamMember', getRoute('ourTeam'))}
            />
            <Route path="*" element={<Navigate replace to={getRoute('ourTeam')} />} />
        </Routes>
    )
};
